import React from "react";
import { IconAlertTriangle } from "@tabler/icons-react";
import ExportCSVButton from "./ExportCSVButton";

export const KPISubgroup = ({ title, icon: Icon, children, color = "#64748b" }) => (
  <div className="kpi-subgroup">
    <div className="kpi-subgroup__header">
      {Icon && (
        <span className="kpi-subgroup__icon" style={{ color }}>
          <Icon size={14} />
        </span>
      )}
      <span className="kpi-subgroup__title">{title}</span>
      <span className="kpi-subgroup__line" />
    </div>
    <div className="kpi-grid">{children}</div>
  </div>
);

const SkeletonGrid = ({ count = 4 }) => (
  <div className="kpi-grid">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="kpi-card kpi-card--skeleton">
        <div className="kpi-card__skeleton-line" />
        <div className="kpi-card__skeleton-value" />
        <div className="kpi-card__skeleton-line" />
      </div>
    ))}
  </div>
);

const BlockSection = ({
  title, subtitle, icon: Icon, color = "#3b82f6",
  loading, error, onRetry, onExport, children, hidden = false,
}) => {
  if (hidden) return null;
  return (
    <section className="insights-block fade-in">
      <header className="insights-block__header">
        {Icon && (
          <div className="insights-block__icon" style={{ background: color }}>
            <Icon size={20} />
          </div>
        )}
        <div>
          <h2 className="insights-block__title">{title}</h2>
          {subtitle && <p className="insights-block__subtitle">{subtitle}</p>}
        </div>
        {onExport && (
          <ExportCSVButton
            onExport={onExport}
            disabled={loading || !!error}
          />
        )}
      </header>
      <div className="insights-block__body">
        {loading ? (
          <SkeletonGrid count={4} />
        ) : error ? (
          <div className="insights-block__error">
            <IconAlertTriangle size={20} />
            <span>{error}</span>
            {onRetry && (
              <button className="insights-block__retry" onClick={onRetry}>
                Tentar novamente
              </button>
            )}
          </div>
        ) : (
          children
        )}
      </div>
    </section>
  );
};

export default BlockSection;
